import { cn } from '@utils/utils';
import Button from '@components/atoms/Button';
import { SearchTabsProps } from '@interfaces/search-component.types';
import { SearchType } from '@interfaces/search.types';
import styles from '../../organisms/SearchComponent/SearchComponent.module.scss';

export const SearchTabs = ({
  activeTab,
  onTabChange,
  variant
}: SearchTabsProps) => {
  return (
    <div className={styles.stickyTabContainer}>
      <div className={styles.tabContainer}>
        <Button
          className={cn(styles.tab, activeTab === 'cars' && styles.active)}
          onClick={() => onTabChange('cars' as SearchType)}
        >
          Cars
        </Button>
        <Button
          className={cn(styles.tab, activeTab === 'blogs' && styles.active)}
          onClick={() => onTabChange('blogs' as SearchType)}
        >
          Articles
        </Button>
      </div>
    </div>
  );
};

export default SearchTabs; 